<div class="transactions-container">
  <fsx-activity-menu-bar
    [workspaceTabCount]="workspaceTabCount$ | async"
  ></fsx-activity-menu-bar>
  <router-outlet></router-outlet>
</div>
